import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './Settings.scss';

const Settings = props => {
  const { pageTitle, canonical, strings } = props;
  const helmet = (
    <Helmet>
      <meta charSet="utf-8" />
      <title>{strings[pageTitle] || pageTitle}</title>
      <meta name="description" content={strings[pageTitle] || pageTitle} />
      <link rel="canonical" href={canonical} />
    </Helmet>
  );

  return (
    <div className="coog-app">
      {helmet}
      <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || pageTitle}</h1>
      <div className="md-body md-cell md-cell--12">Coming soon...</div>
    </div>
  );
};

Settings.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
};
Settings.defaultProps = {
  pageTitle: 'title.setting',
  canonical: 'http://www.coopengo.com/',
  strings: {},
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
    strings: state.toJS().settings.strings,
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);
